import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
import { companyLabel, GRUPO, ESTADO, fmtDate } from './c360Shared';

const JourneyItem = ({ p }) => {
  const e = ESTADO[p.estado] || { label: p.estado, cls: 'bg-slate-100' };
  return (
    <li className="relative pl-6 pb-5 last:pb-0" data-testid={`c360-journey-item-${p.id}`}>
      <span className={`absolute left-0 top-1.5 w-3 h-3 rounded-full ring-4 ring-white ${p.estado === 'hora_de_mudar' ? 'bg-rose-600' : p.estado === 'inativo' || p.estado === 'substituido' ? 'bg-slate-300' : 'bg-[#4DD4E8]'}`} />
      <Link to={`/contracts/${p.service_category || 'luz_gas'}/${p.company}/${p.id}`} className="block rounded-xl border border-slate-200 bg-white p-3 hover:border-[#4DD4E8] transition-colors">
        <div className="flex flex-wrap items-center gap-2 justify-between">
          <div className="flex items-center gap-2 text-sm font-semibold text-slate-800">
            <span className="text-slate-500 font-normal">{p.de ? companyLabel(p.de) : 'Primeira contratação'}</span>
            <ArrowRight className="w-4 h-4 text-[#2D3E6F]" />
            <span>{companyLabel(p.company)}</span>
          </div>
          <span className={`text-[10px] font-bold px-2 py-0.5 rounded-full ${e.cls}`} data-testid={`c360-journey-estado-${p.id}`}>{e.label}</span>
        </div>
        <div className="mt-1 flex flex-wrap gap-x-4 gap-y-0.5 text-xs text-slate-500">
          <span>Assinado {fmtDate(p.data)}</span>
          {p.codigo && <span className="font-mono">{p.codigo}</span>}
          {p.data_fim_fidelizacao && <span>Fim fidelização {fmtDate(p.data_fim_fidelizacao)}</span>}
          {p.comercial && <span>{p.comercial}</span>}
        </div>
        <div className={`mt-1 text-xs ${p.estado === 'hora_de_mudar' ? 'text-rose-700 font-semibold' : 'text-slate-600'}`}>{p.msg}</div>
      </Link>
    </li>
  );
};

const Timeline = ({ items }) => (
  <ol className="relative border-l border-slate-200 ml-1.5">
    {items.map((p) => <JourneyItem key={p.id} p={p} />)}
  </ol>
);

const GroupTimeline = ({ items, grupo }) => {
  const locais = [...new Set(items.map((p) => p.local))];
  if (locais.length < 2) return <Timeline items={items} />;
  return (
    <div className="space-y-4">
      {locais.map((l, i) => {
        const its = items.filter((p) => p.local === l);
        const last = its[its.length - 1];
        const ponto = [last.cpe && `CPE ${last.cpe}`, last.cui && `CUI ${last.cui}`].filter(Boolean).join(' · ');
        return (
          <div key={l} className="rounded-xl border border-dashed border-slate-300 p-2" data-testid={`c360-journey-local-${grupo}-${i}`}>
            <div className="px-1 pb-2 text-xs">
              <span className="font-bold text-[#2D3E6F]">Local {i + 1}</span>
              {ponto && <span className="font-mono text-slate-500"> · {ponto}</span>}
              {last.morada && <span className="block text-slate-500 truncate">{last.morada}</span>}
            </div>
            <Timeline items={its} />
          </div>
        );
      })}
    </div>
  );
};

export const ClientJourney = ({ percurso }) => {
  const groups = ['energia', 'telecomunicacoes', 'alarmes'].filter((g) => percurso.some((p) => p.grupo === g));
  return (
    <div className="rounded-2xl border border-slate-200 bg-slate-50/50 p-4 space-y-4" data-testid="c360-journey">
      <div>
        <h2 className="text-base md:text-lg font-bold font-[Outfit] text-[#2D3E6F]">Percurso do cliente</h2>
        <p className="text-xs text-slate-500">Todos os contratos por ordem de data: de onde veio → para onde foi.</p>
      </div>
      {groups.length === 0 && <div className="text-sm text-slate-500" data-testid="c360-journey-empty">Ainda sem contratos.</div>}
      <div className="grid gap-4 lg:grid-cols-3">
        {groups.map((g) => (
          <div key={g} data-testid={`c360-journey-group-${g}`}>
            <span className={`inline-block mb-3 text-xs font-semibold px-2.5 py-0.5 rounded-full border ${GRUPO[g].cls}`}>{GRUPO[g].label}</span>
            <GroupTimeline items={percurso.filter((p) => p.grupo === g)} grupo={g} />
          </div>
        ))}
      </div>
    </div>
  );
};
